import React from 'react';

const Parents = () => {
  return (
    <div>
      Parents
      Parents
    </div>
  );
}

export default Parents;
